import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useLang } from "../../lib/i18n";
import { fmtDateTime } from "../../lib/helpers";
import { Section, Field } from "../common";
import { useTeam } from "./leadUtils";

const Row = ({ l, v, testid }) => (v ? <div data-testid={testid}><div className="label">{l}</div><div className="text-slate-900 whitespace-pre-wrap break-words">{v}</div></div> : null);

export function LeadInfo({ c, onChange }) {
  const { t, lang } = useLang();
  const team = useTeam();
  const assign = async (user_id) => {
    try { await api.patch(`/customers/${c.id}/assign`, { user_id: user_id || null }); toast.success(t("Assignment saved", "Asignación guardada")); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  const camp = Object.entries(c.lead_campaign || {}).map(([k, v]) => `${k}: ${v}`).join("\n");
  return (
    <Section title={t("Lead", "Prospecto")} testid="customer-lead-section">
      <div className="p-4 grid gap-3">
        <Field label={t("Assigned to", "Asignado a")}>
          <select className="inp" value={c.assigned_to || ""} onChange={(e) => assign(e.target.value)} data-testid="customer-assign-select">
            <option value="">{t("Unassigned", "Sin asignar")}</option>
            {team.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
          </select>
        </Field>
        <Row l={t("Source", "Fuente")} v={[c.lead_source, c.lead_source_name].filter(Boolean).join(" · ")} testid="customer-lead-source" />
        <Row l={t("Received", "Recibido")} v={fmtDateTime(c.lead_received_at || c.created_at, lang)} testid="customer-lead-received" />
        {c.lead_requests > 1 && <Row l={t("Requests received", "Solicitudes recibidas")} v={String(c.lead_requests)} testid="customer-lead-requests" />}
        <Row l={t("Customer message", "Mensaje del cliente")} v={c.lead_message} testid="customer-lead-message" />
        <Row l={t("Campaign", "Campaña")} v={camp} testid="customer-lead-campaign" />
      </div>
    </Section>
  );
}
